// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"CL-z","carouselContainer":"DL-z"};